__turbopack_context__.v({
  "root": "FoodScoreComponent-module__3S42Aa__root",
});
